import fetchData from "./fetchData";
import {ENDPOINTS} from "./endpoints"
const {ADMIN,USER,HOBBY,FAQ,DASHBOARD,FOUL_WORD}=ENDPOINTS

// Admin Specific
export const loginAdmin = (data) => fetchData({ method: "POST", url: ADMIN.LOGIN, data });
export const registerAdmin = (data) => fetchData({ method: "POST", url: ADMIN.REGISTER, data });
export const updateAdminProfile = (data) => fetchData({ method: "POST", url: ADMIN.UPDATE_PROFILE, data });
export const forgotPassword = (data, token) =>  fetchData({  method: "POST", url: ADMIN.FORGOT_PWD,data, headers: { Authorization:token,}});
export const getAdminDetail = (data) =>  fetchData({  method: "POST", url: ADMIN.GET_ADMIN_DETAILS,data});

// Dashboard Specific
export const fetchCardsData = () => fetchData({ method: "GET", url: DASHBOARD.TOP_CARDS });
export const fetchGenderRatio = () => fetchData({ method: "GET", url: DASHBOARD.GENDER_RATIO });
export const fetchJoinedPerMonth = () => fetchData({ method: "GET", url: DASHBOARD.JOINED_PER_MONTH });
 export const fetchSubscriptionPerMonth = () => fetchData({ method: "GET", url: DASHBOARD.SUBSCRIPTION_PER_MONTH });

// User Specific
export const fetchUserData = ({ page = 1, limit = 10 } = {}) => {
  const url = `${USER.GET_USERS}?page=${page}&limit=${limit}`;
  return fetchData({ method: "GET", url });
};
export const fetchUserDetail = (data) => fetchData({ method: "POST", url: USER.USER_DETAIL, data });
export const toggleDeactivate = (data) => fetchData({ method: "POST", url: USER.DEACTIVATE_TOGGLE, data });
export const toggleUserVerify = (data) => fetchData({ method: "POST", url: USER.VERIFY_USER_TOGGLE, data });
export const deleteUser = (data) => fetchData({ method: "POST", url: USER.DELETE_USER, data });

//Reported Users
export const fetchReportedData = () => fetchData({ method: "GET", url: USER.REPORTED_USERS});
export const updateReportStatus = (id, data) => fetchData({ method: "PATCH", url: `${USER.UPDATE_REPORT_STATUS}/${id}`, data });


// HOBBY Specific
export const fetchHobbyData = () => fetchData({ method: "GET", url: HOBBY.GET_ALL_HOBBY });
export const addCategory = (data) => fetchData({ method: "POST", url: HOBBY.ADD_CATEGORY, data });
export const addHobbies = (data) => fetchData({ method: "POST", url: HOBBY.ADD_HOBBY, data });
export const deleteHobby = (data) => fetchData({ method: "POST", url: HOBBY.DELETE_HOBBY, data });
export const deleteCategory = (data) => fetchData({ method: "POST", url: HOBBY.DELETE_CATEGORY, data });


//FOUL WORDS  
export const fetchFoulWords = ({ page = 1, limit = 20 } = {}) => {
  const url = `${FOUL_WORD.GET_FOUL_WORDS}?page=${page}&limit=${limit}`;
  return fetchData({
    method: "GET",
    url,
  });
};
export const editFoulWords = (data) => fetchData({ method: "POST", url: FOUL_WORD.EDIT_FOUL_WORDS, data });
export const improveFoulWordsByAI = () => fetchData({ method: "GET", url: FOUL_WORD.IMPORVE_BY_AI });
export const addFoulWords = (data) => fetchData({ method: "POST", url: FOUL_WORD.ADD_FOUL_WORDS, data });
export const deleteFoulWord = (data) => fetchData({ method: "POST", url: FOUL_WORD.DELETE_FOUL_WORD, data });

// FAQ
export const fetchAllFaq = (data) => fetchData({ method: "GET", url: FAQ.GET_ALL_FAQ });
export const faqStatus = (data) => fetchData({ method: "POST", url: FAQ.FAQ_STATUS, data });
export const addFaq = (data) => fetchData({ method: "POST", url: FAQ.ADD_FAQ, data });
export const editFaq = (data) => fetchData({ method: "POST", url: FAQ.EDIT_FAQ, data });
export const deleteFaq = (data) => fetchData({ method: "POST", url: FAQ.DELETE_FAQ, data });


// Genreal
export const getCountries = () => fetchData({ method: "GET", url: ENDPOINTS.COUNTRY });
